export type RegionKeys =
    11675 | 12579 | 11586 | 11581 | 11582 | 11583 | 11584 | 11588 | 11589 | 11590 | 11591 | 11609 | 11610 | 11611 |
    11612 | 11575 | 11574 | 11572 | 11573 | 11592 | 11593 | 11594 | 11595 | 11596 | 11597 | 11598 | 11599 | 11605 |
    11606 | 11607 | 11608 | 11613 | 11614 | 11615 | 11616 | 11617 | 11618 | 11619 | 11620 | 11621 | 11622 | 11623 |
    11624 | 11625 | 11626 | 11627 | 11628 | 12575 | 12576 | 12574 | 12577 | 11629 | 11630 | 11631 | 11632 | 11633 |
    11634 | 11635 | 11636 | 11637 | 11638 | 11639 | 11640 | 12675 | 12744 | 12745 | 12746 | 12747 | 12676 | 12748 |
    12749 | 12750 | 12751 | 12677 | 12752 | 12753 | 12754 | 12755 | 12756 | 12757 | 13453 | 13454 | 13455 | 13456 |
    13457 | 13458 | 13459 | 13460 | 13697 | 13699 | 13700 | 13701 | 13702 | 13703 | 13704 | 13705 | 13676 | 13677 |
    13678 | 14257;

export const testRegionDict: {
    [key in RegionKeys]: number
} = {

    11675: 1672,        // 首屏区-深读
    12579: 1673,        // 首屏区-大视野
    14257: 2165,        // 首屏区-视频

    11586: 1674,        // 体育-要闻

    11581: 1675,        // 财经-要闻
    11582: 1724,        // 财经-宏观  //楼市
    11583: 1725,        // 财经-股票  //股市
    11584: 1726,        // 财经-楼市  //民生

    11588: 1676,        // 娱乐-要闻
    11589: 1727,        // 娱乐-明星
    11590: 1728,        // 娱乐-影视
    11591: 1729,        // 娱乐-综艺

    11609: 1677,        // 军事-要闻
    11610: 1731,        // 军事-国防  //武器
    11611: 1732,        // 军事-环球
    11612: 1733,        // 军事-战争史

    11575: 1678,        // 美图-娱乐
    11574: 1679,        // 美图-时尚
    11572: 1680,        // 美图-旅游
    11573: 1681,        // 美图-美食

    11592: 1682,        // 健康-要闻
    11593: 1734,        // 健康-养生
    11594: 1735,        // 健康-医疗
    11595: 1736,        // 健康-两性健康

    11596: 1683,        // 汽车-要闻
    11597: 1737,        // 汽车-买车
    11598: 1738,        // 汽车-用车
    11599: 1739,        // 汽车-车视频

    11605: 1684,        // 科技-要闻
    11606: 1740,        // 科技-互联网
    11607: 1741,        // 科技-通讯
    11608: 1742,        // 科技-数码  //科学

    11613: 1685,        // 时尚-要闻
    11614: 1743,        // 时尚-时装
    11615: 1744,        // 时尚-美容
    11616: 1745,        // 时尚-男士

    11617: 1686,        // 教育-要闻
    11618: 1746,        // 教育-中小学
    11619: 1747,        // 教育-高考
    11620: 1748,        // 教育-校园

    11621: 1687,        // 文化-要闻
    11622: 1749,        // 文化-人物
    11623: 1750,        // 文化-读书
    11624: 1751,        // 文化-艺术

    11625: 1688,        // 旅游-要闻
    11626: 1752,        // 旅游-国内游
    11627: 1753,        // 旅游-境外游
    11628: 1754,        // 旅游-攻略

    13676: 1954,        // 房产-要闻
    13677: 1955,        // 房产-二手房
    13678: 1956,        // 房产-家居

    12575: 1689,        // 博览-军事
    12576: 1690,        // 博览-体育
    12574: 1691,        // 博览-汽车
    12577: 1692,        // 博览-历史

    11629: 1755,        // 为你推荐-国际
    11630: 1756,        // 为你推荐-人物故事
    11631: 1757,        // 为你推荐-科普
    11632: 1758,        // 为你推荐-观点

    11633: 1759,        // 为你推荐-情感
    11634: 1760,        // 为你推荐-运势
    11635: 1761,        // 为你推荐-测评
    11636: 1762,        // 为你推荐-揭秘

    11637: 1763,        // 为你推荐-美食
    11638: 1764,        // 为你推荐-育儿
    11639: 1765,        // 为你推荐-教程
    11640: 1766,        // 为你推荐-摄影

    12675: 1699,        // 右侧第一矩形
    12744: 1767,        // 右侧第二矩形
    12745: 1768,        // 右侧第三矩形
    12746: 1769,        // 右侧第四矩形
    12747: 1770,        // 右侧第五矩形

    12676: 1700,        // 第一通栏
    12748: 1771,        // 第二通栏
    12749: 1772,        // 第三通栏
    12750: 1773,        // 第四通栏
    12751: 1774,        // 第五通栏

    12677: 1698,        // 第一文字链通栏标签一
    12752: 1775,        // 第一文字链通栏标签二
    12753: 1776,        // 第一文字链通栏标签三

    12754: 1777,        // 第二文字链通栏标签一
    12755: 1778,        // 第二文字链通栏标签二
    12756: 1779,        // 第二文字链通栏标签三

    12757: 1780,        // 第一通栏推广区

    13453: 1867,        // OS-体育-要闻前两条
    13454: 1868,        // OS-财经-要闻前两条
    13455: 1869,        // OS-娱乐-要闻前两条
    13456: 1870,        // OS-科技-要闻前两条
    13457: 1871,        // OS-健康-要闻前两条
    13458: 1872,        // OS-时尚-要闻前两条
    13459: 1873,        // OS-教育-要闻前两条
    13460: 1874,        // OS-文化-要闻前两条

    13697: 1962,        // 广告打底-大事抢先看  //科学观察
    13699: 1963,        // 广告打底-股市热搜榜
    13700: 1964,        // 广告打底-影视研读社
    13701: 1965,        // 广告打底-开心一刻
    13702: 1966,        // 广告打底-生肖财运
    13703: 1967,        // 广告打底-吃点好的
    13704: 1968,        // 广告打底-美妆种草
    13705: 1969,        // 广告打底-职场新鲜事
};



// WEBPACK FOOTER //
// ./src/models/regionDict.ts